export default __webpack_public_path__ + "static/media/section2-bg3-h5.958c9ddd.png";